/*
* This file contains redux actions for analytics for Compare Panel and Compare Popup and Compare Checkbox on the listing page
* the type attributes are equivalent to types of actions defined in @dc/data-layer
* */


// Dispatch when user clicks on compare button or on label/link next to checkbox
export function dispatchClickCompareButton(productsIDs) {
  return (dispatch) => {
    dispatch({
      type: 'COMPARE_BUTTON_ONCLICK',
      payload: {
        products: productsIDs,
        trackFunctionArgs: 'compareItems'
      }
    });
  };
}

// Uncheck product from comparison analytics dispatcher
export function dispatchUncheckProduct(productId) {
  return (dispatch) => {
    dispatch({
      type: 'UNCHECK_PRODUCT_FROM_COMPARE',
      payload: {
        products: productId,
        trackFunctionArgs: 'removeComparisonItem'
      }
    });
  };
}

// Uncheck product from comparison analytics dispatcher
export function dispatchClearAllProducts(productIds) {
  return (dispatch) => {
    dispatch({
      type: 'CLEAR_ALL_PRODUCTS_FROM_COMPARE',
      payload: {
        products: productIds,
        trackFunctionArgs: 'removeAllComparisonItems'
      }
    });
  };
}

// When popup is displayed dispatch id of the product for analytics
export function dispatchClickProductImage(productId) {
  return (dispatch) => {
    dispatch({
      type: 'COMPARE_PANEL_DISPLAY_POPUP',
      payload: {
        products: productId,
        trackFunctionArgs: 'comparisonListClick'
      }
    });
  };

}

// When a user clicks on the comparison check box dispatch populate the events
export function dispatchComparisonCheckClick(productID, checkboxStatus, errorMessage) {
  return (dispatch) => {
    dispatch({
      type: 'CLICK_ON_CHECKBOX',
      payload: {
        products: productID,
        status: checkboxStatus,
        error: errorMessage,
        trackFunctionArgs: 'comparisonCheckClick'
      }
    });
  };
}
